import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row align-items-center mb-1 pb-2 border-bottom-sm" }
const _hoisted_6 = { class: "col-12 col-md-5 col-lg-3" }
const _hoisted_7 = { class: "col-12 col-sm-6 col-md-4 col-lg-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "col-12 col-sm-6 col-md-3 col-lg-4"
}
const _hoisted_10 = { class: "row align-items-center mb-1 pb-2 border-bottom-sm" }
const _hoisted_11 = { class: "col-12 col-md-5 col-lg-3" }
const _hoisted_12 = { class: "col-12 col-md-4 col-lg-2" }
const _hoisted_13 = {
  key: 0,
  class: "col-12 col-sm-6 col-md-3 col-lg-4"
}
const _hoisted_14 = { class: "row align-items-center" }
const _hoisted_15 = { class: "col-12 col-md-5 col-lg-3" }
const _hoisted_16 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_19 = { class: "card-body p-4" }
const _hoisted_20 = { class: "row g-3" }
const _hoisted_21 = { class: "col-12 col-sm-6 col-md-3" }
const _hoisted_22 = { class: "bg-white h-100 d-flex align-items-center shadow-xs" }
const _hoisted_23 = { class: "col-12 col-sm-6 col-md-3" }
const _hoisted_24 = { class: "p-3 bg-white h-100 d-flex align-items-center shadow-xs" }
const _hoisted_25 = { class: "col-12 col-sm-6 col-md-3" }
const _hoisted_26 = { class: "p-3 bg-white h-100 d-flex align-items-center shadow-xs" }
const _hoisted_27 = { class: "col-12 col-sm-6 col-md-3" }
const _hoisted_28 = { class: "p-3 bg-white h-100 d-flex align-items-center shadow-xs" }
const _hoisted_29 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_30 = { class: "card-body p-4" }
const _hoisted_31 = { class: "row align-items-start" }
const _hoisted_32 = { class: "col-12 col-md-10 col-lg-8" }
const _hoisted_33 = { class: "d-flex flex-column gap-2" }
const _hoisted_34 = { class: "pt-1" }
const _hoisted_35 = {
  key: 0,
  class: "ms-4 ps-2 mt-2"
}
const _hoisted_36 = { class: "d-flex justify-content-center w-100 mt-4" }

import {computed, onMounted, reactive, ref, watch} from 'vue'
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import Datepicker from "@/components/picker/Datepicker.vue";
import PageTemplate from "@/components/PageTemplate.vue";
import Menu from "@/views/App/Portal/CaseManagementCoaching/Menu.vue";
import Loader from "@/components/Loader.vue";
import CoachingOverviewData from "@/views/App/Portal/CaseManagementCoaching/CoachingOverviewData.vue";
import {piniaUserStore} from "@/store/piniaUserStore";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";
import {CloseToast, ErrorToast, SuccessToast} from "@/components/VueToast";
import portalService from "@/api/Unemployed/CaseManagementCoaching";
import {requiredRule} from "@/shared/validators/validationRules";
import useVuelidate from "@vuelidate/core";
import BaseInput from "@/components/base/BaseInput.vue";
import portalCoachingService from "@/api/Portal/CaseManagementCoaching";
import SaveButton from '@/components/button/SaveButton.vue';

type NullableDate = string | null

interface BillCreatedDate {
  billDate: string;
  billNumber: string;
}

interface FormData {
  coachingId: number;
  reportCreated: boolean
  reportCreatedDate: NullableDate

  reportSent: boolean
  reportSentDate: NullableDate

  billCreated: boolean
  billCreatedDates: BillCreatedDate[]

  needsAnalysis: boolean
  recommendationLetter: boolean
  confidentialityRelease: boolean
  privacyPolicy: boolean

  clerk: boolean,
  courseNet: boolean,
  recommendationFromOtherParticipants: boolean,
  socialMedia: boolean,
  others: boolean,
  othersDescription: string,
}



export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const {t} = useI18n();
const route = useRoute();
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const isLoaded = ref(false);
const isSubmitting = ref(false);
const coachingData = ref('');
const coachingId = +route.params.id;

const formData = reactive<FormData>({
  coachingId: 0,
  reportCreated: false,
  reportCreatedDate: null,

  reportSent: false,
  reportSentDate: null,

  billCreated: false,
  billCreatedDates: [],

  needsAnalysis: false,
  recommendationLetter: false,
  confidentialityRelease: false,
  privacyPolicy: false,

  clerk: false,
  courseNet: false,
  recommendationFromOtherParticipants: false,
  socialMedia: false,
  others: false,
  othersDescription: '',
})

const billDates = computed(() => (formData.billCreatedDates ?? []).map(item => item.billDate));

const formRules = ref({});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.coachingId = +coachingId;
    await portalCoachingService.submitDocuments(formData);

    await getDocumentsData();

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getCoachingData() {
  try {
    CloseToast();
    const {data} = await portalService.getCaseManagementCoaching(+coachingId);

    coachingData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getDocumentsData() {
  try {
    const {data} = await portalCoachingService.getDocuments(+coachingId);
    Object.assign(formData, {
      ...data.data,
    });
  } catch (error) {
    await ErrorToast(error);
  }
}

watch(() => formData.reportCreated, (val) => {
  if (!val) {
    formData.reportCreatedDate = null
    formRules.value = {...formRules.value, reportCreatedDate: ''};
  } else {
    formRules.value = {...formRules.value, reportCreatedDate: requiredRule(t)};
  }
})

watch(() => formData.reportSent, (val) => {
  if (!val) {
    formData.reportSentDate = null
    formRules.value = {...formRules.value, reportSentDate: ''};
  } else {
    formRules.value = {...formRules.value, reportSentDate: requiredRule(t)};
  }
})

watch(
    () => formData.others,
    (value: boolean) => {
      if (value) {
        formRules.value = {...formRules.value, othersDescription: requiredRule(t),}
      } else {
        formData.othersDescription = ''
        formRules.value = {...formRules.value, othersDescription: '',}
      }
    }
)


onMounted(async () => {
  await Promise.all([
    getCoachingData(),
    getDocumentsData()
  ]);

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CoachingOverviewData, { coaching: coachingData.value }, null, 8, ["coaching"]),
              _createVNode(Menu, {
                coaching: coachingData.value,
                currentUser: piniaCurrentUser.value
              }, null, 8, ["coaching", "currentUser"]),
              (isLoaded.value)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _withModifiers(submitForm, ["prevent"]),
                    novalidate: "",
                    class: "container-fluid py-3 px-lg-4"
                  }, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-center mt-4 mb-4" }, [
                      _createElementVNode("h5", null, "Dokumente")
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                        _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, "Abschlussbericht & Rechnung")
                      ], -1)),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(BaseCheckbox, {
                              modelValue: formData.reportCreated,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.reportCreated) = $event)),
                              label: "Abschlussbericht erstellt",
                              labelPosition: "right",
                              class: "fw-bold m-0"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_Transition, { name: "fade" }, {
                              default: _withCtx(() => [
                                (formData.reportCreated)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createVNode(Datepicker, {
                                        modelValue: formData.reportCreatedDate,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.reportCreatedDate) = $event)),
                                        required: true,
                                        validation: _unref(v$)?.reportCreatedDate,
                                        messages: _unref(v$)?.reportCreatedDate?.required?.$message,
                                        class: "m-0 shadow-sm"
                                      }, null, 8, ["modelValue", "validation", "messages"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          (formData.reportCreated)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("span", { class: "text-faded p-2 mt-1" }, " Datum der Erstellung des Abschlussberichts ", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(BaseCheckbox, {
                              modelValue: formData.reportSent,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.reportSent) = $event)),
                              label: "Abschlussbericht versendet",
                              labelPosition: "right",
                              class: "mb-md-0 mb-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_Transition, { name: "fade" }, {
                              default: _withCtx(() => [
                                (formData.reportSent)
                                  ? (_openBlock(), _createBlock(Datepicker, {
                                      key: 0,
                                      modelValue: formData.reportSentDate,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.reportSentDate) = $event)),
                                      required: true,
                                      validation: _unref(v$)?.reportSentDate,
                                      messages: _unref(v$)?.reportSentDate?.required?.$message,
                                      class: "shadow-sm"
                                    }, null, 8, ["modelValue", "validation", "messages"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          (formData.reportSent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("span", { class: "text-faded p-2 mt-1" }, " Datum des Versands des Abschlussberichts ", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(BaseCheckbox, {
                              modelValue: formData.billCreated,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.billCreated) = $event)),
                              label: "Rechnung erstellt",
                              labelPosition: "right",
                              disabled: true,
                              class: "mb-md-0 mb-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billDates.value, (date, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index,
                                style: {"margin-right":"8px"}
                              }, [
                                _createTextVNode(_toDisplayString(date), 1),
                                (index !== billDates.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, ","))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                        _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, "Dokumente")
                      ], -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.needsAnalysis,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.needsAnalysis) = $event)),
                                label: "Bedarfsanalyse",
                                labelPosition: "right",
                                class: "m-0"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.recommendationLetter,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.recommendationLetter) = $event)),
                                label: "Empfehlungsschreiben",
                                labelPosition: "right",
                                class: "m-0"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.confidentialityRelease,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.confidentialityRelease) = $event)),
                                label: "Schweigepflichtsentbindung",
                                labelPosition: "right",
                                class: "m-0"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.privacyPolicy,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.privacyPolicy) = $event)),
                                label: "Datenschutzerklärung",
                                labelPosition: "right",
                                class: "m-0"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                        _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, "BSG bekannt durch")
                      ], -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.clerk,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.clerk) = $event)),
                                label: "Sachbearbeiter",
                                labelPosition: 'right',
                                class: "pb-2 border-bottom-sm"
                              }, null, 8, ["modelValue"]),
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.courseNet,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.courseNet) = $event)),
                                label: "Kursnet",
                                labelPosition: 'right',
                                class: "pb-2 border-bottom-sm"
                              }, null, 8, ["modelValue"]),
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.recommendationFromOtherParticipants,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.recommendationFromOtherParticipants) = $event)),
                                label: "Empfehlung od drugih učesnika",
                                labelPosition: 'right',
                                class: "pb-2 border-bottom-sm"
                              }, null, 8, ["modelValue"]),
                              _createVNode(BaseCheckbox, {
                                modelValue: formData.socialMedia,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.socialMedia) = $event)),
                                label: "Social Media",
                                labelPosition: 'right',
                                class: "pb-2 border-bottom-sm"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_34, [
                                _createVNode(BaseCheckbox, {
                                  modelValue: formData.others,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.others) = $event)),
                                  label: "Sonstiges",
                                  labelPosition: 'right',
                                  class: "pb-2"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_Transition, { name: "fade" }, {
                                  default: _withCtx(() => [
                                    (formData.others)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                          _createVNode(BaseInput, {
                                            modelValue: formData.othersDescription,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.othersDescription) = $event)),
                                            validation: _unref(v$)?.othersDescription,
                                            messages: _unref(v$)?.othersDescription?.required?.$message,
                                            placeholder: "Bitte beschreiben..."
                                          }, null, 8, ["modelValue", "validation", "messages"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(SaveButton, {
                        label: _ctx.$t('general.button.save'),
                        loading: isSubmitting.value
                      }, null, 8, ["label", "loading"])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})